import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";

import {
  Text,
  Flex,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Button,
  Textarea,
  RadioGroup,
  Stack,
  SimpleGrid,
  AbsoluteCenter,
  Center,
  useColorModeValue,
  useColorMode,
  Image,
  Skeleton,
  SkeletonText
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import CustomCheckbox from "../../../components/Checkbox/CustomCheckbox";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import axios from "axios";
import apiUrl from "variables/api";

import darkStyles from "variables/darkStyles";

import "./style.css";

const initialValues = {
  inspectObject: "",
  encountered: "",
  irregularities: [],
  raportEnd: "",
  signatures: "",
  file: "",
};

const validate = (values) => {
  const errors = {};
  const requiredFields = Object.keys(initialValues);

  requiredFields.forEach((field) => {
    if (!values[field] && field !== "irregularities") {
      errors[field] = "To pole jest obowiazkowe";
    }
  });

  if (values.encountered === "TAK" && values.irregularities.length === 0) {
    errors.irregularities = "To pole jest obowiazkowe";
  }

  return errors;
};
function Page() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);

    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      setPreview(null);
    }
  };
  const [formData, setFormData] = useState(initialValues);

  const [peoples, setPeoples] = useState([]);
  useEffect(() => {
    axios
      .get(apiUrl + "/data/peoples", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(response.data);
        setPeoples(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const formikRef = React.useRef();
  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    console.log("Dane formularza", values);
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key === "file") {
        formData.append(key, values[key]);
      } else {
        formData.append(key, JSON.stringify(values[key]));
      }
    });
    setFormData(values);
    axios
      .post(apiUrl + "/data/k-r-inspection", formData, {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          formikRef.current.resetForm();
          setSelectedFile(null);
          setPreview(null);
          formikRef.current.setSubmitting(false);
          return toast.success("Pomyślnie wysłano inspekcję");
        } else {
          formikRef.current.setSubmitting(false);
          return toast.error("Napotkano błąd podczas wysyłania inspekcji");
        }
      })
      .catch((error) => {
        console.error(error);
        formikRef.current.setSubmitting(false);
        toast.error("Napotkano błąd podczas połączenia z API");
      });
  };
  const { colorMode } = useColorMode();

  const reasons = [
    {
      label: "alkohol/narakotyki",
      value: "alkohol/narakotyki",
      color: "red",
    },
    {
      label: "leki",
      value: "leki",
      color: "red",
    },
    {
      label: "wymuszenie pierwszeństwa przejazdu",
      value: "wymuszenie pierwszeństwa przejazdu",
      color: "red",
    },
    {
      label: "przekroczenie obowiązującej szybkości",
      value: "przekroczenie obowiązującej szybkości",
      color: "red",
    },
    {
      label: "nieostrożność",
      value: "nieostrożność",
      color: "red",
    },
    {
      label: "nieprzestrzeganie przepisów",
      value: "nieprzestrzeganie przepisów",
      color: "red",
    },
    {
      label: "przemęczenie",
      value: "przemęczenie",
      color: "red",
    },
    {
      label: "wady techniczne",
      value: "wady techniczne",
      color: "red",
    },
    {
      label: "wina innego kierowcy",
      value: "wina innego kierowcy",
      color: "red",
    },
    {
      label: "przyczyna niezależna od kierowcy",
      value: "przyczyna niezależna od kierowcy",
      color: "red",
    },
    {
      label: "inna",
      value: "inna",
      color: "red",
    },
  ];

  return (
    <Flex flexDirection="column" pt={{ base: "160px", md: "75px" }}>
      <Card minH="125px">
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={handleSubmit}
          innerRef={formikRef}
        >
          {({ isSubmitting, values }) => (
            <Form>
              <SimpleGrid
                columns={{ sm: 1, md: 2, xl: 4 }}
                spacing="24px"
                mb="20px"
              >
                <Field name="inspectObject">
                  {({ field, form }) => (
                    <FormControl
                      id="inspectObject"
                      isRequired
                      isInvalid={
                        form.errors.inspectObject && form.touched.inspectObject
                      }
                    >
                      <FormLabel>Czego dokonano inspekcji?</FormLabel>
                      <Input {...field} placeholder="Treść" />
                      <FormErrorMessage>
                        {form.errors.inspectObject}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="encountered">
                  {({ field, form }) => (
                    <FormControl
                      id="encountered"
                      isRequired
                      isInvalid={
                        form.errors.encountered && form.touched.encountered
                      }
                    >
                      <FormLabel>Napotkano nieprawidłowości?</FormLabel>
                      <RadioGroup name="encountered" colorScheme="red">
                        <Stack direction="row">
                          <CustomCheckbox
                            key="TAK"
                            label="TAK"
                            isChecked={form.values.encountered == "TAK"}
                            onChange={() => {
                              form.setFieldValue(field.name, "TAK");
                            }}
                          />
                          <CustomCheckbox
                            key="NIE"
                            label="NIE"
                            isChecked={form.values.encountered == "NIE"}
                            onChange={() => {
                              form.setFieldValue(field.name, "NIE");
                            }}
                          />
                        </Stack>
                      </RadioGroup>
                      <FormErrorMessage>
                        {form.errors.encountered}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="raportEnd">
                  {({ field, form }) => (
                    <FormControl
                      id="raportEnd"
                      isRequired
                      isInvalid={
                        form.errors.raportEnd && form.touched.raportEnd
                      }
                    >
                      <FormLabel>Zakończenie</FormLabel>
                      <Textarea {...field} placeholder="Treść" maxH={"500px"} />
                      <FormErrorMessage>
                        {form.errors.raportEnd}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="signatures">
                  {({ field, form }) => (
                    <FormControl
                      id="signatures"
                      isRequired
                      isInvalid={
                        form.errors.signatures && form.touched.signatures
                      }
                    >
                      <FormLabel>Podpisy</FormLabel>
                        <ReactSelect
                          {...field}
                          noOptionsMessage={() => "Brak dostępnych opcji"}
                          options={peoples}
                          isLoading={peoples.length === 0}
                          placeholder="Wybierz..."
                          styles={darkStyles()}
                          value={form.values.signatures}
                          isMulti
                          onChange={(selectedOptions) => {
                            form.setFieldValue(field.name, selectedOptions);
                          }}
                        />
                      <FormErrorMessage>
                        {form.errors.signatures}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                <Field name="file">
                  {({ field, form }) => (
                    <FormControl
                      id="file"
                      isRequired
                      isInvalid={form.errors.file && form.touched.file}
                    >
                      <FormLabel>Screenshot</FormLabel>
                      <label htmlFor="file-upload">
                        <input
                          id="file-upload"
                          type="file"
                          accept=".png, .jpg"
                          style={{ display: "none" }} // Ukrywanie domyślnego inputa
                          onChange={(event) => {
                            const file = event.target.files[0];
                            setSelectedFile(file);
                            const filetosend = form.setFieldValue(
                              field.name,
                              file
                            );

                            if (file && file.type.startsWith("image/")) {
                              const reader = new FileReader();
                              reader.onloadend = () => {
                                setPreview(reader.result); // Ustawiamy podgląd obrazu
                              };
                              reader.readAsDataURL(file); // Wczytujemy obraz jako URL
                            } else {
                              setPreview(null); // Resetujemy podgląd, jeśli plik nie jest obrazem
                            }
                          }}
                        />
                        <Button as="span" colorScheme="red" variant="solid">
                          Wybierz plik
                        </Button>
                      </label>
                      {selectedFile && (
                        <Text mt={2} fontSize="sm">
                          Wybrany plik: {selectedFile.name}
                        </Text>
                      )}

                      {preview && (
                        <Image
                          src={preview}
                          alt="Podgląd obrazu"
                          height={"100px"}
                          mt={2}
                          objectFit="cover"
                          borderRadius="md"
                        />
                      )}

                      <FormErrorMessage>{form.errors.file}</FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
                {values.encountered === "TAK" && (
                  <Field name="irregularities">
                    {({ field, form }) => (
                      <FormControl
                        id="irregularities"
                        isRequired
                        isInvalid={
                          form.errors.irregularities &&
                          form.touched.irregularities
                        }
                      >
                        <FormLabel>Wybierz nieprawidłowości</FormLabel>
                        <SimpleGrid>
                          {[
                            "- Nieprawidłowości dotyczące instrukcji postępowania na wypadek pożaru wraz z wykazem telefonów alarmowych",
                            "- Nieprawidłowości dotyczące instrukcji bezpieczeństwa pożarowego",
                            "- Nieprawidłowości dotyczące zaznajomienia z przepisami przeciwpożarowymi",
                            "- Nieprawidłowości dotyczące instalacji użytkowych",
                            "- Nieprawidłowości dotyczące stanu dróg ewakuacyjnych (drożności, skladowania materiałów palnych) i znaków bezpieczeństwa",
                            "- Nieprawidłowości dotyczące dróg pożarowych",
                            "- Nieprawidłowości dotyczące zaopatrzenia w wodę",
                            "- Nieprawidłowości dotyczące dźwiękowych systemów ostrzegawczych",
                            "- Nieprawidłowości dotyczące systemów sygnalizacji pożarowej",
                            "- Nieprawidłowości dotyczące instalacji wodociągowych przeciwpożarowych",
                            "- Nieprawidłowości dotyczące gaśnic",
                            "- Nieprawidłowości dotyczące braku wymaganych oświetleń awaryjnych",
                            "- Nieprawidłowości w zakresie zabezpieczenia przed zadymieniem dróg ewakuacyjnych",
                            "- Nieprawidłowości w zakresie wystroju korytarzy albo pomieszczeń",
                            "- Nieprawidłowości w zakresie długości lub szerokości dróg ewakuacyjnych",
                          ].map((irregularity) => (
                            <CustomCheckbox
                              key={irregularity}
                              label={irregularity}
                              isChecked={field.value.includes(irregularity)}
                              onChange={() => {
                                const nextValue = field.value.includes(
                                  irregularity
                                )
                                  ? field.value.filter(
                                      (value) => value !== irregularity
                                    )
                                  : [...field.value, irregularity];
                                form.setFieldValue(field.name, nextValue);
                              }}
                            />
                          ))}
                        </SimpleGrid>
                        <FormErrorMessage>
                          {form.errors.irregularities}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                )}
              </SimpleGrid>

              <Button
                mt={4}
                colorScheme="red"
                isLoading={isSubmitting}
                type="submit"
              >
                Wyślij
              </Button>
            </Form>
          )}
        </Formik>
      </Card>
    </Flex>
  );
}

export default Page;
